import { DTO_GRAPH__edge } from '@shared/dto/generation/graph_invoke/_graph/DTO_GRAPH__edge';
import { G_SIDEBAR__edges_item } from './edge/G_SIDEBAR__edges_item';

interface PROPS {
  title: string;
  edges: DTO_GRAPH__edge[];
  name_type: 'from' | 'to' | 'full';
  className?: string;
}

export function G_SIDEBAR__edges({ title, edges, name_type, className = '' }: PROPS) {
  /*
   * HTML
   */

  if (edges.is_empty()) return null;

  return (
    <div className={`flex flex-col gap-y-1 mb-3 px-2  w-full min-h-0 ${className}`}>
      <div className="text-xs text-bar-foreground p-1">{title}</div>
      {edges.map(edge => (
        <G_SIDEBAR__edges_item key={edge.edge_id} {...{ edge, name_type }} />
      ))}
    </div>
  );
}
